import React from 'react'
import PropTypes from 'prop-types'
import ContactCard from '../../common/ContactCard/ContactCard'
import AccessMap from '../../common/AccessMap/AccessMap'
import NewsletterForm from '../../forms/NewsletterForm/NewsletterForm'

export default function WidgetRenderer(props) {
  switch (props.__typename) {
    case 'ContentfulWidgetCarteDeContact':
      return <ContactCard {...props} />
    case 'ContentfulWidgetPlanDacces':
      return <AccessMap {...props} />
    case 'ContentfulWidgetNewsletter':
      return <NewsletterForm />
    default:
      return <></>
  }
}

WidgetRenderer.propTypes = {
  __typename: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}
